import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ArrowForward from '@mui/icons-material/ArrowForward';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CancelIcon from '@mui/icons-material/Cancel';
import { EditSharp, Spa } from '@mui/icons-material';
import { FixedSizeList as List } from 'react-window';
import CircularProgress from '@mui/material/CircularProgress';


function EngineerStockTransfer() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [selectedEngineer, setSelectedEngineer] = useState('');
    const [transferData, setTransferData] = useState({});
    const [selectedStaff, setSelectedStaff] = useState('');
    const [staffOptions, setStaffOptions] = useState([]);
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const { isAuthenticated, companyId, permissions, token, userId, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // fetchData();
    }, [isAuthenticated, companyId, token, userId, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    useEffect(() => {
        fetchStaff();
        fetchTableData();
    }, []);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const [staffId, setStaffId] = useState(false);


    const fetchStaff = async () => {
        try {
            const response = await fetchData('StaffApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(staff => ({
                    // value: staff.firstName + " " + staff.lastName,
                    // label: staff.firstName + " " + staff.lastName,
                    value: staff.firstName,
                    label: staff.firstName,
                    staffId: staff.id
                }));
                setStaffOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Staff:', error);
        }
    };

    const handleStaffChange = (selectedOption) => {
        setSelectedStaff(selectedOption);
        const selectedStaffObject = staffOptions.find(option => option.value === selectedOption.value);
        if (selectedStaffObject) {
            setStaffId(selectedStaffObject.id);
        } else {
            setStaffId('');
        }
    };

    // const fetchTableData = async () => {
    //     try {
    //         const response = await fetchData('SparePartsApi', `/${companyId}`, token);
    //         if (response.responseCode === '1111') {
    //             setData(response.response_data);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching Item Details:', error);
    //         if (error.response && error.response.status === 401) {
    //             logout();
    //             history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
    //         }
    //     }
    // };

    const fetchTableData = async () => {
        setLoading(true);
        try {
            const response = await fetchData('SparePartsApi', `/${companyId}`, token);
            if (response.responseCode == '1111') {
                console.log(response);
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        } finally {
            setLoading(false); // Hide loading screen
        }
    };

    const handleDelete = async () => {
        try {
            await deleteData('EngineerStockApi', `${deleteItemId}`);
            fetchData();
            setDeleteItemId(null);
            setConfirmDialogOpen(false);
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };

    const handleActivate = async (itemId) => {
        try {
            await activateData('EngineerStockApi', `${itemId}`);
            fetchData();
        } catch (error) {
            console.error('Error activating record:', error);
        }
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const [selectedItems, setSelectedItems] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);

    const handleCheckboxChange = (event, itemId) => {
        if (event.target.checked) {
            setSelectedItems([...selectedItems, itemId]);
            setTransferData(prevState => ({
                ...prevState,
                [itemId]: 0 // Default quantity when an item is selected
            }));
        } else {
            setSelectedItems(selectedItems.filter(id => id !== itemId));
            setTransferData(prevState => {
                const newState = { ...prevState };
                delete newState[itemId]; // Remove quantity when an item is deselected
                return newState;
            });
        }
    };

    const handleSelectAllChange = (event) => {
        const isChecked = event.target.checked;
        setSelectAllChecked(isChecked);
        setSelectedItems(isChecked ? data.map(item => item.id) : []);
        if (!isChecked) {
            setTransferData({});
        }
    };

    const handleQuantityChange = (event, itemId) => {
        const { value } = event.target;
        setTransferData(prevState => ({
            ...prevState,
            [itemId]: parseInt(value) || 0, // Ensure quantity is a valid number
        }));
    };



    //const API_URL = 'https://localhost:7291/api/StockMovementApi';
    const API_URL = 'https://pp-api.off-ease.com/api/StockMovementApi';

    const handleSubmit = async () => {
        const transferList = Object.entries(transferData)
            .filter(([itemId, quantity]) => quantity !== undefined)
            .map(([itemId, quantity]) => ({ sparePartsId: itemId, quantity }));

        const transferDataWithStaff = transferList.map(transfer => ({
            ...transfer,
            StaffID: selectedStaff.staffId,
            CompanyID: companyId,
            CreatedBy: userId,
            CreatedDate: new Date(),
            Date: new Date(),

        }));

        try {
            const response = await axios.post(`${API_URL}`, transferDataWithStaff, { mode: 'cors' });
            console.log('Transfer submitted successfully:', response.data);
            setTransferData({});
            setSelectedStaff('');
            // Refresh the page after successful submission
            window.location.reload();
        } catch (error) {
            console.error('Error submitting transfer:', error);
        }
    };


    const filteredData = data.filter(item =>
        Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [notificationList, setNotificationList] = useState([]);
    const StyledHeader = styled.h2`
    font-size: 24px;
    font-weight: bold;
    color: #333; /* Change the color as per your preference */
    text-transform: uppercase;
    border-bottom: 2px solid #ccc; /* Add a border for a more elegant look */
    padding-bottom: 5px; /* Adjust the padding as needed */
    margin-bottom: 20px; /* Add some bottom margin for spacing */
  `;

    useEffect(() => {
        fetchNotificationList();
    }, []);

    const fetchNotificationList = async () => {
        try {
            //const response = await axios.get(`https://localhost:7291/api/NotificationApi/${companyId}`);
            const response = await axios.get(`https://pp-api.off-ease.com/api/NotificationApi/${companyId}`);
            console.log('Response data:', response.data); // Log the response data
            if (Array.isArray(response.data.response_data) && response.data.response_data.length > 0) {
                setNotificationList(response.data.response_data);
            } else {
                console.error('Error: Response data is not an array or is empty');
            }
        } catch (error) {
            console.error('Error fetching notification list:', error);
        }
    };


    const [notificationDetails, setNotificationDetails] = useState(null); // State for holding notification details
    const [showNotificationModal, setShowNotificationModal] = useState(false); // State for managing modal visibility
    // Function to open notification modal
    const openNotificationModal = (notification) => {
        setNotificationDetails(notification);
        setShowNotificationModal(true);
    };

    // Function to close notification modal
    const closeNotificationModal = () => {
        setShowNotificationModal(false);
        setNotificationDetails(null);
    };

    const handleCloseInvoiceDialog = () => {
        setShowNotificationModal(false);
        setNotificationDetails(null);
    };

    const [showModal, setShowModal] = useState(false);

    // Function to toggle modal visibility
    const toggleModal = () => {
        setShowModal(!showModal);
    };

    const [qtyshowModal, setqtyShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [quantity, setQuantity] = useState('');


    const handleRequest = (itemId, spare, spareId, engineerId, staff, quantity, EStkId) => {
        setSelectedItem({ id: itemId, spare: spare, spareId: spareId, engineerId: engineerId, staff: staff, quantity: quantity, EStkId: EStkId });
        setqtyShowModal(true);
    };

    const handleReturn = (item) => {
        setSelectedItem(item);
        setqtyShowModal(true);
    };

    const handleCloseModal = () => {
        setqtyShowModal(false);
        setSelectedItem(null);
        setQuantity('');
    };


    const handleSubmitRequest = async () => {
        try {
            //const APIURL = `https://localhost:7291/api/StockMovementApi/${selectedItem.id}`;
            const APIURL = `https://pp-api.off-ease.com/api/StockMovementApi/${selectedItem.id}`;

            const request = {
                SparePartsID: selectedItem.spareId,
                ID: selectedItem.id,
                EngineerStockID: selectedItem.EStkId,
                StaffID: selectedItem.engineerId,
                CompanyID: companyId,
                Quantity: parseFloat(quantity),
                CreatedBy: userId,
                CreatedDate: new Date().toISOString(),
                Date: new Date().toISOString(),
                IsRequest: true,
                IsReturned: false,
                IsPurchased: false,
                IsClaimed: false,
                IsFinished: false,
            };

            const response = await axios.put(APIURL, request);
            console.log('Transfer submitted successfully:', response.data);
            window.location.reload();
        } catch (error) {
            console.error('Error submitting transfer:', error);
        }
        console.log('Request Text:', quantity);
    };

    const [showengineersparelist, setEngineersparelist] = useState(false);
    const [selectedEngineerSpareData, setSelectedEngineerSpareData] = useState(null);


    const handleHistoryClick = async (itemid) => {
        try {
            const response = await fetchData('EngineerStockTransferApi', `/${companyId}/${itemid}`, token);
            if (response.responseCode === '1111') {
                setSelectedEngineerSpareData(response.response_data);
                console.log(response);
                setEngineersparelist(true);
            }
        } catch (error) {
            console.error('Error fetching Order Items:', error);
        }
    };

    const closeModals = () => {
        setEngineersparelist(false);
    };


    const Row = useCallback(({ index, style }) => {
        const item = filteredData[index];

        return (
            <TableRow key={item.id} className={item.isActive ? '' : 'inactiveRow'} style={{ ...style, backgroundColor: '#D5F5E3' }}>
                <TableCell sx={{ borderBottom: '1px solid #000000', height: '15px', fontSize: '14px', marginLeft: '50px', padding: '3px 3px 3px 30px' }}>{index + 1}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', height: '15px', fontSize: '14px', marginLeft: '50px', width: '150px', padding: '3px 3px 3px 30px' }}>{item.code}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', height: '15px', fontSize: '14px', marginLeft: '50px', width: '500px', padding: '3px 3px 3px 30px' }}>{item.name}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', textAlign: 'right', padding: '3px 3px 3px 30px', height: '15px' }}>
                    <a href="#" onClick={() => handleHistoryClick(item.id)} className="tooltip-link">
                        <h5 className='psheading linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black', cursor: 'pointer' }}>{item.currentStock}</h5>
                    </a>
                </TableCell>
                <TableCell sx={{ borderBottom: '1px solid #000000', height: '15px', padding: '0.0px 0.0px 0.0px 0px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '250px' }}>
                        <input
                            type="checkbox"
                            onChange={(event) => handleCheckboxChange(event, item.id)}
                            checked={selectedItems.includes(item.id)}
                            style={{ height: '17px', textAlign: 'left' }}
                        />
                        {selectedItems.includes(item.id) && (
                            <input
                                type="number"
                                value={transferData[item.id] || ''}
                                onChange={(event) => handleQuantityChange(event, item.id)}
                                min="0"
                                style={{ marginLeft: '-10px' }}
                            />
                        )}
                    </div>
                </TableCell>
            </TableRow>
        );
    }, [filteredData, selectedItems, transferData, handleCheckboxChange, handleQuantityChange, handleHistoryClick]);

    const [isFocused, setIsFocused] = useState(false);

    // const handleSearch = (e) => {
    //     setSearchQuery(e.target.value);
    // };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '95%' }}>
            <div className="w-full mb-2 flex">
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>STOCK TRANSFER</h6>
                {
                    loading && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 9999
                        }}>
                            <div>
                                <CircularProgress style={{ color: 'white' }} />
                                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                            </div>
                        </div>
                    )
                }
                <div style={{ position: 'relative', marginLeft: '-30px' }}>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        style={{
                            width: isFocused ? '250px' : '200px',
                            transition: 'width 0.3s ease, box-shadow 0.3s ease',
                            padding: '10px 15px',
                            border: '1px solid #ccc',
                            borderRadius: '25px',
                            outline: 'none',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : '0 2px 5px rgba(0, 0, 0, 0.1)',
                        }}
                    />
                </div>
                <div className="w-1/4 mr-2">
                    <Select
                        value={selectedStaff}
                        onChange={handleStaffChange}
                        options={staffOptions}
                        placeholder="Select Staff"
                        isSearchable
                        styles={{ width: '250px' }}
                    />
                </div>
                <div style={{ textAlign: 'center', marginLeft: '20px' }}>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>Transfer</Button>
                </div>

            </div>

            <div className="w-full mb-2 flex" style={{ maxHeight: '520px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#090040' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', fontWeight: 'bolder', fontSize: '10px', padding: '3px', textAlign: 'left', color: 'white', textTransform: 'uppercase', width: '50px' }}>
                                    <span style={{ marginLeft: '10px' }}>Sl.No</span>
                                    <span style={{ marginLeft: '50px', color: 'white', fontWeight: 'bolder' }}>Code</span>
                                    <span style={{ marginLeft: '150px', color: 'white', fontWeight: 'bolder' }}>Spare</span>
                                    <span style={{ marginLeft: '350px', color: 'white', fontWeight: 'bolder' }}>CurrentStock</span>
                                    <span style={{ marginLeft: '150px', color: 'white', fontWeight: 'bolder' }}>Transfer
                                        <input type="checkbox" onChange={handleSelectAllChange} checked={selectAllChecked} style={{ marginLeft: '450px', height: '17px', textAlign: 'right' }} />
                                    </span>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#D5F5E3' }}>
                            <List
                                height={500}
                                itemCount={filteredData.length}
                                itemSize={60}
                                width="100%"
                            >
                                {Row}
                            </List>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <Modal
                open={showNotificationModal}
                onClose={closeNotificationModal}
                className={showNotificationModal ? 'notification-modal' : ''}
                style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
            >
                <div style={{ marginTop: '100px', backgroundColor: 'white', padding: '20px', borderRadius: '8px' }}>
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1000px', overflowX: 'auto', overflowY: 'auto' }}>
                        <div className="flex justify-end mt-2" style={{ marginTop: '-45px' }}>
                            <Tooltip title="Close" onClick={handleCloseInvoiceDialog} style={{ cursor: 'pointer' }}>
                                <CancelIcon />
                            </Tooltip>
                        </div>
                        <h5 style={{ fontFamily: 'Tahoma, Geneva, sans-serif', fontSize: '24px', fontWeight: 'bolder', color: '#333', textAlign: 'center', color: "brown" }}>Notifications</h5>

                        {notificationList.length === 0 ? (
                            <p className="text-center">No notifications found</p>
                        ) : (

                            <table className="w-full">

                                <thead>
                                    <tr className="bg-gray-200">
                                        <th className="px-4 py-2">Sl.No</th>
                                        <th className="px-4 py-2">Date</th>
                                        <th className="px-4 py-2">Name</th>
                                        <th className="px-4 py-2">Spare</th>
                                        <th className="px-4 py-2">Available Stock</th>
                                        <th className="px-4 py-2">Req-Quantity</th>
                                        <th className="px-4 py-2">Type</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {notificationList.map((item, index) => (
                                        <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : ''}>
                                            <td className="px-4 py-2 border">{index + 1}</td>
                                            <td className="px-4 py-2 border">{new Date(item.date).toLocaleDateString('en-GB')}</td>
                                            <td className="px-4 py-2 border">{item.staffName}</td>
                                            <td className="px-4 py-2 border">{item.spare}</td>
                                            <td className="px-4 py-2 border">{item.currentstk}</td>
                                            <td className="px-4 py-2 border">{item.quantity}</td>
                                            <td className="px-4 py-2 border">
                                                <span style={{ color: item.type === 'Requested' ? 'red' : 'green' }}>
                                                    {item.type === 'Requested' ? (
                                                        <button aria-label="request" onClick={() => handleRequest(item.id, item.spare, item.sparePartsID, item.staffID, item.staffName, item.quantity, item.engineerStockID)} style={{ marginRight: '10px' }}>Request</button>
                                                    ) : (
                                                        <button onClick={() => handleReturn(item)}>Return</button>
                                                    )}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
                {/* , item.engineerStockID */}
            </Modal>


            <Modal
                className={qtyshowModal ? 'notification-modal' : ''}
                open={qtyshowModal}
                onClose={handleCloseModal}
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }}
            >
                <div style={{ marginTop: '100px', backgroundColor: 'white', borderRadius: '10px' }}>
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '500px' }}>
                        <div className="flex justify-end mt-2" style={{ marginTop: '-45px' }}>
                            <Tooltip title="Close" onClick={handleCloseModal} style={{ cursor: 'pointer' }}>
                                <CancelIcon />
                            </Tooltip>
                        </div>
                        <h6 style={{ fontFamily: 'Tahoma, Geneva, sans-serif', fontSize: '24px', fontWeight: 'bolder', color: '#333', textAlign: 'center', color: "brown", marginTop: '-40px' }}>Stock Transfer</h6>


                        {selectedItem && (
                            <div>
                                <p><strong>Engineer:  <span style={{ color: 'blue', marginRight: '20px' }}>{selectedItem.staff}</span></strong></p>

                                <p style={{ marginTop: '-20px' }}><strong>Item: <span style={{ color: 'blue', marginRight: '20px' }}>{selectedItem.spare}</span></strong></p>

                                <p style={{ marginTop: '-20px' }}><strong>Req-Qty:  <span style={{ color: 'blue', marginRight: '20px' }}>{selectedItem.quantity}</span></strong></p>
                            </div>
                        )}

                        <label style={{ fontSize: '16px' }}>Enter the Quantity</label>
                        <div style={{ width: '500px', display: 'flex' }}>
                            <div style={{ width: '200px', display: 'flex', justifyContent: 'center' }}>
                                <input
                                    type="number"
                                    value={quantity}
                                    onChange={(e) => setQuantity(e.target.value)}
                                    placeholder="Enter quantity"
                                    style={{ textAlign: 'center' }}
                                />
                            </div>
                            <div style={{ marginLeft: '30px' }}>
                                <button
                                    onClick={handleSubmitRequest}
                                    style={{
                                        background: '#4CAF50',
                                        color: 'white',
                                        padding: '12px 20px',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        textDecoration: 'none',
                                        display: 'inline-block',
                                        fontSize: '16px',
                                        transitionDuration: '0.4s',
                                        boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)'
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal >

            {/*for finding which engineer handling the Spares? */}
            <Modal
                className={showengineersparelist ? 'notification-modal' : ''}
                open={showengineersparelist}
                onClose={closeModals}
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }}
            >
                <div style={{ marginTop: '100px', backgroundColor: 'white', borderRadius: '10px' }}>
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '900px' }}>
                        <div className="flex justify-end mt-2" style={{ marginTop: '-45px' }}>
                            <Tooltip title="Close" onClick={closeModals} style={{ cursor: 'pointer' }}>
                                <CancelIcon />
                            </Tooltip>
                        </div>
                        <h6 style={{ fontFamily: 'Tahoma, Geneva, sans-serif', fontWeight: 'bolder', color: '#333', textAlign: 'center', color: "brown", marginTop: '-40px' }}>Spare Parts details</h6>

                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                    <TableRow>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '11px', padding: '7px', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '11px', padding: '7px', textTransform: 'uppercase' }}>Engineer</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '11px', padding: '7px', textTransform: 'uppercase' }}>Spare</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '11px', padding: '7px', textTransform: 'uppercase' }}>Available Stock</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {selectedEngineerSpareData && selectedEngineerSpareData.length > 0 ? (
                                        selectedEngineerSpareData.map((item, index) => (
                                            <TableRow key={item.id} className={item.isActive ? '' : 'inactiveRow'}>
                                                <TableCell sx={{ height: '20px', padding: '5px', fontSize: '13px' }}>{index + 1}</TableCell>
                                                <TableCell sx={{ height: '20px', padding: '5px', fontSize: '13px' }}>{item.engineerName}</TableCell>
                                                <TableCell sx={{ height: '20px', padding: '5px', fontSize: '13px' }}>{item.spareName}</TableCell>
                                                <TableCell sx={{ height: '20px', padding: '5px', fontSize: '13px' }}>{item.balanceQuantity}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={3} sx={{ textAlign: 'center', padding: '20px' }}>
                                                No data available
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </Modal>

        </div >
    );
}

export default EngineerStockTransfer;

